let progressBarFilled = null;
window.addEventListener('scroll', debounce(function () {
    const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight,
        progress = (window.scrollY / scrollHeight) * 100
    ;

    if (!progressBarFilled) {
        progressBarFilled = document.querySelector('.single-progress-bar-filled');
    }
    if (progressBarFilled) {
        progressBarFilled.style.width = progress + '%';
    }
}, {
    wait: 25,
    maxTimeout: 75,
}));
